<section class="bmc-dashboard-uipath__title bz-dsh__header bz-space--inset-squish-m">
    <h4 class=" bz-dsh__title bz-dsh__title--bold">{{ 'RPA_BOTS.CHARTS_UIPATH' | translate }}</h4>
</section>

<bzg-tab-set (onSelectTab)="onTabEvent($event)">
    <bzg-tab-item [displayName]="'Jobs'">
        <biz-uipath-job-dashboard #job [tabIndex]="tabIndex" [dataJobsChart]="dataJobsChart | async"
            [isLoading]="isLoadingJobs$ | async">
        </biz-uipath-job-dashboard>
    </bzg-tab-item>
    <bzg-tab-item [displayName]="'Queueitems'">
        <biz-uipath-queueitem-dashboard #queueitem [tabIndex]="tabIndex"
            [dataQueueitemsChart]="dataQueueitemsChart | async"
            [isLoading]="isLoadingQueueItems$ | async"></biz-uipath-queueitem-dashboard>
    </bzg-tab-item>
</bzg-tab-set>